





























import { Component, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import Loading from './services/Loading'
import TextField from '@/components/form/TextField.vue'
import { compose, defaultFormatter, inputFormatter } from '@/utils/formatters'

@Component({
	components: {
		TextField,
	},
})
export default class DiscountBlock extends Vue {
	$refs!: {
		input: TextField,
	}

	private promoCode?: string = ''

	@Action private validatePromoCode!: (code: string) => Promise<boolean>
	@Action private setDiscount!: (code: String) => void

	private async applyPromoCode() {
		if (!this.promoCode) return
		Loading.show()
		try {
			const isValid = await this.validatePromoCode(this.promoCode)
			if (!isValid) return
			this.setDiscount(this.promoCode)
		} finally {
			Loading.hide()
		}
	}

	private defaultFormatter = defaultFormatter
	private inputFormatter = inputFormatter
	private compose = compose
}
